import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'The Credit Repair Sledgehammer';
render(<App data-id="element-215" />, document.getElementById('root'));